import cx from 'classnames';
import Typography, {
  Props as TypographyPropsProps,
} from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import React, { FC, memo } from 'react';
import './button.css';

export const BUTTON_COLORS = {
  INFO: 'info',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TRANSPARENT: 'transparent',
};

export const BUTTON_VARIANTS = {
  OUTLINE: 'outline',
  TEXT: 'text',
  FILL: 'fill',
};

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: string;
  variant?: string;
  variantFill?: boolean;
  isFillWhenCustomerHover?: boolean;
  TypographyProps?: TypographyPropsProps;
  loading?: boolean;
  noBorder?: boolean;
};

const Button: FC<ButtonProps> = ({
  className,
  variant = BUTTON_VARIANTS.OUTLINE,
  color = BUTTON_COLORS.PRIMARY,
  variantFill,
  isFillWhenCustomerHover = false,
  children,
  TypographyProps,
  disabled,
  loading,
  noBorder,
  ...rest
}) => (
  <button
    {...rest}
    disabled={disabled}
    type="button"
    className={cx(
      'pb-button',
      {
        'pb-button-primary': color === BUTTON_COLORS.PRIMARY,
        'pb-button-secondary': color === BUTTON_COLORS.SECONDARY,

        'pb-button-variant-outline':
          !noBorder && !variantFill && variant === BUTTON_VARIANTS.OUTLINE,
        'pb-button-variant-fill':
          !noBorder && (variantFill || variant === BUTTON_VARIANTS.FILL),
        'pb-button-variant-text':
          !variantFill && (noBorder || variant === BUTTON_VARIANTS.TEXT),

        'pb-button-fill-when-active': !disabled && isFillWhenCustomerHover,
        'pb-button-disabled': disabled,
      },
      className,
    )}
  >
    <Typography
      variant={TYPOGRAPHY_VARIANTS.BODY}
      firstCapCase
      {...TypographyProps}
      className={cx('pb-button-text', TypographyProps?.className)}
    >
      {loading ? (
        <div className="indi-spiner">
          <div />
          <div />
          <div />
          <div />
        </div>
      ) : (
        children
      )}
    </Typography>
  </button>
);

export default memo(Button);
